import React from 'react';
import { useDashboardFeatureFlags, useDashboardPermissions } from '@components';
import { Button } from '@fourthwall/components';
import { ApparelIcon, ButtonIcon, CommentIcon, DocumentDownloadIcon, MoneyIcon, ProfileIcon, TagIcon, } from '@fourthwall/icons';
import { SubscriptionPerk } from '../../../../components/SubscriptionPerk/SubscriptionPerk';
import { useTopSubscriptionPlan } from '../../../../hooks/useTopSubscriptionPlan';
import { formatSubscriptionBytes } from '../../../../utils/formatSubscriptionBytes';
import { getSubscriptionPrice, getSubscriptionSamplesCreditGrant, } from '../../../../utils/getSubscriptionPeriodValue';
import * as S from './IntroStage.styled';
export const IntroStage = ({ onNext, onClose }) => {
    const { hasPermission } = useDashboardPermissions();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const canUserUpgradeSubscription = hasPermission('subscriptions.edit');
    const { topSubscriptionPlan: topSubscriptionPlanMonthly, getTopSubscriptionPlanLimitLabel } = useTopSubscriptionPlan();
    const { topSubscriptionPlan: topSubscriptionPlanYearly } = useTopSubscriptionPlan({
        recurringPeriod: 'YEARLY',
    });
    const getTitle = () => {
        if (!canUserUpgradeSubscription) {
            return "Your account doesn't have permission to upgrade to Pro. Please contact the shop owner to upgrade.";
        }
        return `Grow your brand with Fourthwall Pro for ${getSubscriptionPrice({
            subscriptionPlan: topSubscriptionPlanMonthly,
            options: {
                minimumFractionDigits: 2,
            },
        })} or only ${getSubscriptionPrice({
            subscriptionPlan: topSubscriptionPlanYearly,
            options: {
                minimumFractionDigits: 2,
            },
        })}.`;
    };
    const renderButton = () => {
        if (!canUserUpgradeSubscription) {
            return React.createElement(Button, { label: "Close", appearance: "primary", fullWidth: true, onClick: onClose });
        }
        return React.createElement(Button, { label: "Upgrade to Pro", appearance: "primary", fullWidth: true, onClick: onNext });
    };
    const getStorageLimit = () => {
        const digitalStorageLimit = topSubscriptionPlanMonthly?.digitalProductsStorageLimitBytes || 0;
        const productDesignerStorageLimit = dashboardFeatureFlags
            .subscriptionsProductDesignerStorageLimits.enabled
            ? topSubscriptionPlanMonthly?.productDesignerArtworkStorageLimitBytes || 0
            : 0;
        return formatSubscriptionBytes(digitalStorageLimit + productDesignerStorageLimit);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Content, null,
            React.createElement(S.Text, null, getTitle()),
            React.createElement(S.SecondaryText, null, "What\u2019s included in Fourthwall Pro?"),
            React.createElement(S.PerksContainer, null,
                React.createElement(SubscriptionPerk, { icon: MoneyIcon },
                    getSubscriptionSamplesCreditGrant({
                        subscriptionPlan: topSubscriptionPlanMonthly,
                    }),
                    ' ',
                    "of sample credit"),
                React.createElement(SubscriptionPerk, { icon: ButtonIcon }, "Free domain of your choice"),
                React.createElement(SubscriptionPerk, { icon: TagIcon }, "No fees on digital products"),
                React.createElement(SubscriptionPerk, { icon: ProfileIcon },
                    getTopSubscriptionPlanLimitLabel('members', true),
                    " team members"),
                React.createElement(SubscriptionPerk, { icon: ApparelIcon },
                    getTopSubscriptionPlanLimitLabel('offers', true),
                    " products"),
                dashboardFeatureFlags.subscriptionsStorageLimits.enabled && (React.createElement(SubscriptionPerk, { icon: DocumentDownloadIcon },
                    getStorageLimit(),
                    " of file storage")),
                React.createElement(SubscriptionPerk, { icon: CommentIcon }, "Priority customer support"))),
        React.createElement(S.ButtonWrapper, null, renderButton())));
};
